import React from 'react';
import AnimatedSection from '../AnimatedSection'; 

const MissionVision = ({ item }) => {
  return (
    <>
      <AnimatedSection
        x={50}
        y={0}
        amount={0.4}
      >
        <div className="about-values">
          <div className="about-values-title">
            <h3>{item.title}</h3>
          </div>
          <div className="about-values-content">
            <p>{item.content}</p>
          </div>
        </div>
      </AnimatedSection>
    </>
  );
};

export default MissionVision;
